import React from 'react';
import '../styles/StaticPages.css';

export default function Terms() {
  return (
    <div className="static-page">
      <div className="static-page-container">
        <h1>תנאי שימוש</h1>
        <p className="last-updated">עדכון אחרון: ינואר 2026</p>
        
        <section className="page-section">
          <h2>1. קבלת התנאים</h2>
          <p>
            בגישה לאתר Punkontrol ושימוש בו, אתם מסכימים להיות קשורים בתנאי שימוש אלה.
            אם אינכם מסכימים לכל התנאים, אנא הימנעו משימוש באתר.
          </p>
        </section>

        <section className="page-section">
          <h2>2. שימוש באתר</h2>
          <p>אתם מתחייבים:</p>
          <ul>
            <li>להשתמש באתר למטרות חוקיות בלבד</li>
            <li>לא להעלות תוכן פוגעני, גזעני או אלים</li>
            <li>לכבד זכויות יוצרים של אחרים</li>
            <li>לא לנסות לפגוע באבטחת האתר</li>
            <li>לא לבצע ספאם או פרסומות לא רצויות</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>3. תוכן משתמשים</h2>
          <p>
            אתם שומרים על כל הזכויות ליצירות שאתם מעלים לאתר. 
            על ידי העלאת תוכן, אתם מעניקים ל-Punkontrol רישיון לא בלעדי להציג, 
            להפיץ ולקדם את התוכן במסגרת השירות.
          </p>
          <p>
            אתם מצהירים שהתוכן שאתם מעלים הוא שלכם או שיש לכם הרשאה להעלות אותו.
          </p>
        </section>

        <section className="page-section">
          <h2>4. התנהגות אסורה</h2>
          <p>אסור לעשות שימוש באתר למטרות הבאות:</p>
          <ul>
            <li>הפרת זכויות יוצרים או קניין רוחני</li>
            <li>הטרדה, איומים או פגיעה במשתמשים אחרים</li>
            <li>פרסום מידע כזב או מטעה</li>
            <li>העלאת תוכן בלתי חוקי או מזיק</li>
          </ul>
        </section>

        <section className="page-section">
          <h2>5. הפסקת חשבון</h2>
          <p>
            אנו שומרים את הזכות להשעות או למחוק חשבונות שמפרים את תנאי השימוש,
            ללא הודעה מוקדמת ולפי שיקול דעתנו הבלעדי.
          </p>
        </section>

        <section className="page-section">
          <h2>6. שינויים בתנאים</h2>
          <p>
            אנו רשאים לעדכן את תנאי השימוש מעת לעת. 
            המשך השימוש באתר לאחר שינויים מהווה הסכמה לתנאים המעודכנים.
          </p>
        </section>

        <section className="page-section">
          <h2>7. הגבלת אחריות</h2>
          <p>
            השירות ניתן "כמות שהוא" וללא אחריות מכל סוג. 
            לא נהיה אחראים לנזקים ישירים או עקיפים הנובעים משימוש באתר.
          </p>
        </section>

        <section className="page-section">
          <h2>8. יצירת קשר</h2>
          <p>
            לשאלות בנוגע לתנאי השימוש, אנא צרו קשר דרך <a href="/contact">עמוד יצירת הקשר</a>.
          </p>
        </section>
      </div>
    </div>
  );
}
